import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/LayOut.vue'
import DashboardView from '../views/DashboardView.vue'
import AccountsView from '../views/AccountsView.vue'
import BrokerageView from '../views/ClientsView.vue'
import PerfomanceView from '../views/RevenueView.vue'
import ExpensiveView from '../views/ExpensiveView.vue'
// import IncentiveView from '../views/IncentiveView.vue'
import ExpectEmail from '../views/ExpectEmail.vue'

import StatementVIew from '../views/StatementVIew.vue'
import AccountsPage from '../views/ProfileView.vue'
import LogIn from '../components/GoogleSso.vue'
import SideBar from '../views/SideBar.vue'
import MutualFund from '../views/MutualFund.vue'
import AllOrder from '../views/AllOrderMf.vue'
import DailyOrders from '../views/DailyOrders.vue'
import MandateDetails from '../views/MandateDetails.vue'
import RedemptionRequest from '../views/RedemptionRequest.vue'
import SipPage from '../views/SipPage.vue'
import HoldingsPage from '../views/HoldingsPage.vue'
import MFNfosrc from '../views/MFNfosrc.vue'
import MfOrderbookSrc from '../views/MfOrderbookSrc.vue'
import CloserSrc from '../views/CloserSrc.vue'
import RekycRequest from '../views/RekycRequest.vue'





Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'LogIn',
        component: LogIn
    },
    {
        path: '/sidebar',
        name: 'sidebar',
        component: SideBar
    },

    {
        path: '/',
        redirect: 'signin',
        name: 'Homeview',
        component: HomeView,
        children: [{
                path: '/dashboard',
                name: 'dashboard',
                component: DashboardView
            },
            {
                path: '/clients',
                name: 'clients',
                component: BrokerageView
            },
            {
                path: '/revenue',
                name: 'perfomance',
                component: PerfomanceView
            },
            {
                path: '/statement',
                name: 'statement',
                component: StatementVIew
            },
            {
                path: '/expensive',
                name: 'expensive',
                component: ExpensiveView
            },
            // {
            //     path: '/incentive',
            //     name: 'incentive',
            //     component: IncentiveView
            // },
            {
                path: '/accounts',
                name: 'accounts',
                component: AccountsView
            },
            {
                path: '/user',
                name: 'settings',
                component: AccountsPage
            },
            {
                path: '/mfpage',
                name: 'MutualFund',
                component: MutualFund
            },
            {
                path: '/allorder',
                name: 'AllOrder',
                component: AllOrder
            },
            {
                path: '/dailyorders',
                name: 'DailyOrders',
                component: DailyOrders
            },
            {
                path: '/redemptionrequest',
                name: 'RedemptionRequest',
                component: RedemptionRequest
            },
            {
                path: '/mandatedetails',
                name: 'MandateDetails',
                component: MandateDetails
            },
            {
                path: '/sip',
                name: 'SipPage',
                component: SipPage
            },
            {
                path: '/holdings',
                name: 'HoldingsPage',
                component: HoldingsPage
            },
              {
                path: '/nfo',
                name: 'MFNfosrc',
                component: MFNfosrc
            },
             {
                path: '/mfobook',
                name: 'MfOrderbookSrc',
                component: MfOrderbookSrc
            },
            {
                path: '/closer',
                name: 'CloserSrc',
                component: CloserSrc
            },
            {
                path: '/rekyc',
                name: 'RekycRequest',
                component: RekycRequest
            },


        ]
    },

    {
        path: '/brmail',
        name: 'email',
        component: ExpectEmail
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        window.scrollTo(0, 0);
    }
})

export default router